import React from 'react';
import styled from 'styled-components';
import layout from "./comps/layout";
import RenderContent from "./comps/renderContent";
import { createBrowserHistory } from 'history';
export const history = createBrowserHistory({
    basename: process.env.PUBLIC_URL
});


const Logo = styled.img`
  margin: 0 0 3% 0;
  width: 340px;
  max-width: 100%
`;
const PlaymobilLogo = styled.img`
  max-width: 71%;
  margin-left: 34px;
  @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
    margin-left: 11%;
  }
`;
const LangButton = styled.button`
  float:left;
  font-size: ${props => props.theme.fontSizes.small};
  font-weight: 700;
  text-transform: uppercase;
  color: #fff;
  border: 1px solid #fff;
  padding: 3px 13px;
  background-color: ${props => (props.theme.colors.bg2)};
  :focus{
    outline: -webkit-focus-ring-color auto 0px;
    outline-color: -webkit-focus-ring-color;
    outline-style: auto;
    outline-width: 0px;
  }
  :hover{
    cursor: pointer;
  }
  @media (min-width: ${props => (props.theme.breaks.mobile+1)}px) {
    font-size: ${props => props.theme.fontSizes.smallDesktop};
  }
`;
const LangBtnWrap = styled.div`
  margin: 0 auto;
  display: table;
  position:absolute;
  top:42px;
  padding:0 30px;


  box-sizing: border-box;
  @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
    padding:0 10px;
    top:13px;
  }
`;





export default class Page extends React.Component {
  constructor(props) {
      super(props);
      const detectBrowserLanguage = require('detect-browser-language');
      this.state = {
        lang: detectBrowserLanguage().split("-")[0]
      };
      this.setLang = this.setLang.bind(this);
    };
  setLang() {
    this.setState(prevState => ({
      lang: prevState.lang === 'de'?'en':'de'
    }));
  };

  render() {
    return (
        <layout.PageWrap>
          <LangBtnWrap>
            <LangButton onClick={this.setLang}>
              {this.state.lang === 'de' ? 'EN' : 'DE'}
            </LangButton>
          </LangBtnWrap>
          <layout.Header>
            <a href={this.state.lang === "de" ? "/" : "/en/"} title="Homepage" style={{display:'block'}}>
              <Logo src={this.state.lang === "de" ? "./img/layout/DSM_RZ_Logo_weiss_d.svg" : "./img/layout/DSM_RZ_Logo_weiss_e.svg"} style={this.state.lang === "de" ? {} : {width:"300px"}} alt="DSM Logo" />
            </a>
            <PlaymobilLogo src="./img/layout/playmobilLogo.svg" alt="playmobil Logo" />
          </layout.Header>
          <RenderContent lang={this.state.lang} />
        </layout.PageWrap>
    );
  }
}
